import type { ContentNugget } from './nugget';

export type AppRoute = Readonly<{
  INTERNSHIP: string;
  EMPLOYER: string;
  COMPETENCY: string;
  UNIVERSITY: string;
}>;

// The Grow paths buildShareUrl can target. Shared so a link built outside Grow
// can't drift from the route Grow actually serves.
export const GROW_SHARE_ROUTES: AppRoute = {
  INTERNSHIP: '/internship',
  EMPLOYER: '/employer',
  COMPETENCY: '/competency',
  UNIVERSITY: '/university',
};

type BuildShareUrlParams = Readonly<{
  contentNugget: ContentNugget;
  growUrl: string;
  appRoute: AppRoute;
}>;

export const buildShareUrl = ({
  contentNugget,
  growUrl,
  appRoute,
}: BuildShareUrlParams): string => {
  const defaultShareUrl = `${growUrl}/nuggets?nugget=${contentNugget.slug}`;

  switch (contentNugget.variant) {
    case 'scholarships':
      return `${growUrl}/nuggets?scholarship=${contentNugget.scholarship_info?.id}`;

    case 'internship':
      return `${growUrl}${appRoute.INTERNSHIP}/${contentNugget.internship_info?.id}`;

    case 'profile-internal':
      return `${growUrl}/profile/${contentNugget.profile_info?.id}`;

    case 'profile-external':
      return `${contentNugget.external_profile_info?.url}`;

    case 'career-path':
      return `${growUrl}/career-paths/${contentNugget.career_path_info?.id}`;

    case 'post':
      return `${growUrl}?post=${contentNugget.post_info?.id}`;

    case 'generated-content':
      return `${growUrl}/nuggets?generated-content=${contentNugget.generated_content_info?.uuid}`;

    case 'employer':
      return `${growUrl}${appRoute.EMPLOYER}/${contentNugget.employer_info?.slug}`;

    case 'competency':
      return `${growUrl}${appRoute.COMPETENCY}/${contentNugget.slug}`;

    case 'institution':
      if (contentNugget.college_info) {
        return `${growUrl}${appRoute.UNIVERSITY}/${contentNugget.college_info.id}`;
      }

      return defaultShareUrl;

    case 'tool':
      if (contentNugget.tool_info?.navigation.type === 'INTERNAL') {
        return `${growUrl}${contentNugget.tool_info.navigation.internal_navigation_url}`;
      }
      if (contentNugget.tool_info?.navigation.type === 'EXTERNAL') {
        return contentNugget.tool_info.navigation.external_navigation_url;
      }

      return defaultShareUrl;

    case 'major':
      return `${growUrl}/majors/${contentNugget.major_info?.id}`;

    case 'industry':
      return `${growUrl}/industries/${contentNugget.industry_info?.id}`;

    case 'coach':
      return `${growUrl}/profile/${contentNugget.coach_info?.id}`;

    case 'deep-dive':
      return `${growUrl}/deep-dives/${contentNugget.deep_dive_info?.id}`;

    default:
      return defaultShareUrl;
  }
};
